import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const InspectorField = props => (
  <div className={`inspectorField ${props.className ? props.className : null}`} style={props.style}>
    {props.label ? <label>{props.label}</label> : null}
    {props.children}
  </div>
);

InspectorField.propTypes = {
  label: PropTypes.string,
  children: PropTypeShapes.elementOrArrayOrString,
  style: PropTypes.object,
  className: PropTypes.string
};

export default InspectorField;
